import { render, staticRenderFns } from "./DictManage.vue?vue&type=template&id=039f3241&scoped=true"
import script from "./DictManage.vue?vue&type=script&lang=js"
export * from "./DictManage.vue?vue&type=script&lang=js"
import style0 from "./DictManage.vue?vue&type=style&index=0&id=039f3241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f3241",
  null
  
)

export default component.exports